'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertContainer = require('./AlertContainer');

var _AlertContainer2 = _interopRequireDefault(_AlertContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AlertContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-alert/dist/alert-container/index.js
// module id = 947
// module chunks = 0